
import { useEffect, useRef, useState } from "react";
import { UIRefreshCategoryEnum } from "../../common/enums/UIRefreshCategoryEnum";
import { useOfflineDetectContext } from "../../contexts/offline-detect-context/UseOfflineDetectContext";
 import { useUserContext } from "../../contexts/user-context/UserContext";
import { useInterval } from "../use-interval/UseInterval";

export type DataRefreshProps = {
    dataRefresh: () => void;
    category?: UIRefreshCategoryEnum,
    intervalSeconds?: number;

};
export function useAutoRefresh({ dataRefresh, category, intervalSeconds }: DataRefreshProps): void {


    const callbackRef = useRef<() => void>(undefined);
    const categoryRef = useRef<UIRefreshCategoryEnum | undefined>(undefined);

    const [userState] = useUserContext();    
    const [offlineState] = useOfflineDetectContext();

    // AutoRefresh support
    // determine the refresh interval for the view
    const [autoRefreshInterval, setAutoRefreshInterval] = useState(() => {
        const seconds = intervalSeconds ?? userState
         .refreshIntervals
         .find(o => o.category === category)?.refreshSeconds ?? (15 * 60);
        return seconds ? seconds * 1000 : undefined;
    });

    const onAutoRefresh = () => {

        if (callbackRef.current) {
            callbackRef.current();
        }
    };

    // use the useInterval custom hook to handle timer and callback to refresh the data
    useInterval(onAutoRefresh, offlineState.offline ? undefined : autoRefreshInterval);

    // Remember the latest callback.
    useEffect(() => {

        callbackRef.current = dataRefresh;
        categoryRef.current = category;

    }, [dataRefresh, category]);

    useEffect(() => {
        if (intervalSeconds && autoRefreshInterval !== (intervalSeconds * 1000)) {
            setAutoRefreshInterval((intervalSeconds * 1000));
        }
    }, [autoRefreshInterval,
        setAutoRefreshInterval,
        intervalSeconds
    ]);
}